module.exports = __webpack_public_path__ + "static/media/Right_Arrow.1ac7e49f.svg";